import { CurrencyFormatter } from '@common/utils/formatCurrency';

export const formattedCurrency = (value: number | undefined) => {
  if (value === undefined) {
    return '-';
  }
  return isNaN(value) ? '-' : CurrencyFormatter.format(Math.round(value));
};
